<template>
    <div class="business">
        <Visual :title="'BUSINESS'" :background="'business'"/>
        <div class="box-wrapper">
            <GradientBox class="business-box" :transition="'gradient-box'">
                <div class="business-box__label is-lato">BUSINESS</div>
                <div class="business-box__text">
                    <p class="title is-lato">BUSINESS <br class="desktop-break">AREA</p>
                    <p :class="['desc', 'is-locale-' + $store.getters.getLocale]" v-html="$t('business.desc')"></p>
                </div>
            </GradientBox>
        </div>
        <div class="content">
            <div class="desktop" v-if="$resize && $mq.above(1024)">
                <div class="shape-wrapper">
                    <div class="shape1"  v-parallax="0.2"></div>
                    <div class="shape2"  v-parallax="-0.4"></div>
                </div>
                <Scrollama @step-enter="setVisible" :offset="0.8">
                    <div class="category-title">
                        <sequential-entrance delay="150" animation="itemIn" tag="div">
                        <a class="item"
                            v-for="(item, index) in category"
                            :key="index"
                            @click="$store.commit('setBusinessType', index + 1)"
                            href="#"
                            v-scroll-to="'#' + item"
                            :class="index + 1 === $store.getters.getBusinessType ? 'is-active' : '' ">
                            <div :class="['symbol', 'symbol' + (index + 1), activeSymbol()]"></div>
                            <p class="title" v-html="$t('business.section01.sub0' + (index + 1) + '.title')"></p>
                        </a>
                        </sequential-entrance>
                    </div>
                    <div class="category-content">
                        <transition-group name="category" mode="in-out">
                            <div class="item"
                                v-for="(item, index) in category"
                                :key="item"
                                :id="item"
                                v-show="index + 1 == categoryInit()"
                                :class="'is-active-' + (index + 1)">
                                <div :class="['item-inner', 'is-active-' + (index + 1)]">
                                    <div class="box">
                                        <p :class="['title', 'is-locale-' + $store.getters.getLocale]"
                                        v-html="$t('business.section01.sub0' + (index + 1) + '.subTitle')"></p>
                                        <div class="button-wrapper">
                                            <button class="prev" @click="prev"></button>
                                            <button class="next" @click="next"></button>
                                        </div>
                                    </div>
                                    <div class="desc">
                                        <p v-html="$t('business.section01.sub0' + (index + 1) + '.desc')"></p>
                                        <a :href="$t('business.section01.sub0' + (index + 1) + '.link')" target="_blank"
                                            v-html="$t('business.section01.sub0' + (index + 1) + '.linkTitle')"
                                            :class="'link-' + (index + 1)"></a>
                                    </div>
                                </div>
                            </div>
                        </transition-group>
                    </div>
                </Scrollama>
            </div>
            <div class="mobile" v-else-if="$resize && $mq.above(320)">
                <ul class="category">
                    <sequential-entrance delay="150" animation="itemIn" tag="div">
                    <li class="item"
                        v-for="(item, index) in category"
                        :key="index"
                        @click="afterScroll('#' + item)"
                        :class="index + 1 === $store.getters.getBusinessType ? 'is-active' : '' ">
                        <div :id="item" class="top-point"></div>
                        <div class="title-wrapper" @click="setOpenDesc(index + 1)">
                            <div :class="['symbol', 'symbol' + (index + 1), activeSymbol()]"></div>
                            <p class="title" v-html="$t('business.section01.sub0' + (index + 1) + '.title')"></p>
                        </div>
                        <slide-up-down :active="index + 1 === $store.getters.getBusinessType"
                            :class="['desc-wrapper', 'desc' + (index + 1)]">
                            <div class="desc">
                                <p v-html="$t('business.section01.sub0' + (index + 1) + '.desc')"></p>
                                <a :href="$t('business.section01.sub0' + (index + 1) + '.link')" target="_blank"
                                    v-html="$t('business.section01.sub0' + (index + 1) + '.linkTitle')"
                                    :class="'link-' + (index + 1)"
                                    @click.stop></a>
                            </div>
                        </slide-up-down>
                    </li>
                    </sequential-entrance>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import 'intersection-observer'
import Scrollama from 'vue-scrollama'
import Visual from '@/components/common/Visual'
import GradientBox from '@/components/common/GradientBox'
import SlideUpDown from 'vue-slide-up-down'
import VueScrollTo from 'vue-scrollto'

export default {
    name: 'Business',
    components: { Scrollama, SlideUpDown, Visual, GradientBox },
    metaInfo: {
        titleTemplate: '%s | BUSINESS',
        meta: [
            { name: 'description', content: '큐브플랫폼은 직구, 역직구 사업에 필요한 진보된 솔루션을 제공합니다. 솔루션, 물류, 커뮤니케이션 걱정 없이 전세계 60억 시장에 진출하실 수 있습니다.' },
            { name: 'property="og:description"', content: '큐브플랫폼은 직구, 역직구 사업에 필요한 진보된 솔루션을 제공합니다. 솔루션, 물류, 커뮤니케이션 걱정 없이 전세계 60억 시장에 진출하실 수 있습니다.' }
        ]
    },
    data: function () {
        return {
            category: ['platform', 'logistics', 'fulfillment', 'contactcenter']
        }
    },
    methods: {
        setVisible: function (el) {
            el.element.classList.add('is-active')
        },
        next: function () {
            let type = this.$store.getters.getBusinessType
            if (type === 0) type = 1
            type++
            if (type >= this.category.length + 1) type = 1
            this.$store.commit('setBusinessType', type)
            return type
        },
        prev: function () {
            let type = this.$store.getters.getBusinessType
            type--
            if (type < 1) type = this.category.length
            this.$store.commit('setBusinessType', type)
            return type
        },
        setOpenDesc: function (i) {
            if (this.$store.getters.getBusinessType !== i) {
                this.$store.commit('setBusinessType', i)
            } else {
                this.$store.commit('setBusinessType', false)
            }
        },
        activeSymbol: function () {
            var index = this.$store.getters.getBusinessType
            return 'is-active-' + index
        },
        categoryInit: function () {
            if (!this.$store.getters.getBusinessType) {
                return 1
            } else {
                return this.$store.getters.getBusinessType
            }
        },
        afterScroll: function (val) {
            setTimeout(function () {
                VueScrollTo.scrollTo(val, 500)
            }, 500)
        }
    },
    mounted: function () {
        var boxBreak = document.getElementsByClassName('box-break')
        Array.prototype.forEach.call(boxBreak, function (el) {
            el.style.display = 'none'
        })
        if (!this.categoryInit) this.categoryInit = 1
    }
}
</script>

<style lang="scss" scoped>
@import '@/assets/style/mixin.scss';
@keyframes gradient {
    0% {background-position: 0% 50%;}
    50% {background-position: 100% 50%;}
    100% {background-position: 0% 50%;}
}
@keyframes item-visible {
    0% {transform: translateY(30px); opacity: 0;}
    100% {transform: translateY(0); opacity: 1;}
}
.itemIn {
    position: relative;
    animation: item-visible 1000ms;
}

@include over-desktop {
    .box-wrapper {
        position: relative;
        top: -70px;
        width: 1200px;
        margin: 0 auto;
    }
    .business-box {
        position: absolute;
        right: 0;
        width: 386px;
        height: 386px;
        padding: 70px;
        white-space: nowrap;

        @keyframes label {
            0% {opacity: 0; transform: rotate(90deg) translateX(100px);}
            100% {opacity: 1; transform: rotate(90deg) translateX(0);}
        }
        &__label {
            position: absolute;
            top: 150px;
            right: 40px;
            font-weight: 700;
            font-size: 16px;
            color: #fff;
            letter-spacing: 16px;
            transform: rotate(90deg);
            transform-origin: top right;
            animation: label 750ms ease 750ms backwards;

            &::before {
                content: '';
                display: block;
                position: absolute;
                top: 50%;
                left: -80px;
                width: 60px;
                height: 1px;
                background: #fff;
                opacity: 0.3;
            }
        }
        &__text {
            color: #fff;
            .title {
                font-size: 32px;
                line-height: 36px;
            }
            .desc {
                margin-top: 38px;
                font-size: 16px;
                line-height: 24px;
                letter-spacing: -1.5px;
                opacity: 0.7;
                // &.is-locale-kr {}
                &.is-locale-jp {
                    font-size: 15;
                    line-height: 21px;
                }
            }
        }
    }
    .content {
        width: 100%;

        .desktop {
            .shape-wrapper {
                position: relative;
                width: 1200px;
                height: 100%;
                z-index: -1;
                margin: 0 auto;
                .shape1 {
                    position: absolute;
                    top: -120px;
                    right: 19%;
                    width: 395px;
                    height: 363px;
                    background: url(../assets/image/business/shape_01.png) no-repeat center;
                    background-size: 100% auto;
                }
                .shape2 {
                    position: absolute;
                    top: 640px;
                    right: -10%;
                    width: 345px;
                    height: 297px;
                    background: url(../assets/image/business/shape_02.png) no-repeat center;
                    background-size: 100% auto;
                    transform: translateY(200px);
                }
            }
            .category-title {
                width: 1200px;
                margin: 0 auto;
                padding: 100px 0;

                .item {
                    display: block;
                    width: 65%;
                    margin-top: 10px;

                    &:first-child {
                        margin-top: 0;
                    }

                    &::after {
                        content: '';
                        display: block;
                        clear: both;
                    }
                }
                .symbol {
                    float: left;
                    width: 154px;
                    height: 140px;
                    @for $i from 1 to 5 {
                        &.symbol#{$i} {
                            background: url(../assets/image/business/icon0#{$i}.png) no-repeat center;
                            // background-size: 100% auto;
                        }
                    }
                    @for $i from 1 to 5 {
                        &.symbol#{$i}.is-active-#{$i} {
                            background: url(../assets/image/business/icon0#{$i}-active.png) no-repeat center;
                            // background-size: 100% auto;
                        }
                    }
                }
                .title {
                    float: left;
                    position: relative;
                    margin-left: 30px;
                    color: #444;
                    font-size: 22px;
                    line-height: 140px;
                    letter-spacing: -1px;

                    &::after {
                        content: '';
                        display: block;
                        position: absolute;
                        top: 50%;
                        right: -24px;
                        width: 7px;
                        height: 11px;
                        background: url(../assets/image/business/category_arrow.png) no-repeat center;
                        transform: translateY(-50%);
                    }
                }
                .item:hover {
                    .symbol {
                        @for $i from 1 to 5 {
                            &.symbol#{$i} {
                                background: url(../assets/image/business/icon0#{$i}-active.png) no-repeat center;
                                // background-size: 100% auto;
                            }
                        }
                    }
                    .title::after {
                        background: url(../assets/image/business/category_arrow_on.png) no-repeat center;
                    }
                }
                .item.is-active {
                    .title::after {
                        background: url(../assets/image/business/category_arrow_on.png) no-repeat center;
                    }
                }
            }
            .category-content {
                position: relative;
                width: 100%;
                height: 600px;
                margin: 0 auto 100px;

                .item {
                    width: 100%;
                    height: 100%;
                    @for $i from 1 to 5 {
                    &.is-active-#{$i} {
                        background: url(../assets/image/business/category_0#{$i}.png) no-repeat center;
                        background-size: cover;
                    }
                }
                }
                .item-inner {
                    position: absolute;
                    top: 0;
                    left: 50%;
                    width: 1200px;
                    height: 100%;
                    margin: 0 auto;
                    transform: translateX(-50%);
                }
                .box {
                    @include gradient-45;
                    position: absolute;
                    top: 50%;
                    // left: 42px;
                    left: 0;
                    width: 285px;
                    height: 285px;
                    padding: 50px 40px;
                    background-size: 800%;
                    animation: gradient 18s infinite;
                    // transform: translateY(-50%);

                    &::before {
                        content: '';
                        display: block;
                        position: absolute;
                        top: 78px;
                        left: -42px;
                        width: 71px;
                        height: 10px;
                        background: url(../assets/image/common/before-title-white.svg) no-repeat center;
                        background-size: 100% auto;
                    }
                    .title {
                        color: #fff;
                        font-size: 30px;
                        line-height: 38px;
                        white-space: nowrap;
                        &.is-locale-kr {
                            letter-spacing: -0.06px;
                            margin-left: 10px;
                        }
                        &.is-locale-jp {
                            font-size: 28px;
                            letter-spacing: -2px;
                        }
                    }
                    .button-wrapper {
                        position: absolute;
                        left: 50px;
                        bottom: 40px;

                        .prev,
                        .next {
                            position: relative;
                            float: left;
                            width: 42px;
                            height: 42px;
                            border: 1px solid rgba(255, 255, 255, 0.3);
                            cursor: pointer;
                            outline: none;
                            -webkit-tap-highlight-color: rgba(0,0,0,0);
                            &::before {
                                content: '';
                                display: block;
                                position: absolute;
                                top: 50%;
                                left: 50%;
                                transform: translate(-50%, -50%);
                                width: 8px;
                                height: 12px;
                                background: url(../assets/image/business/slide_arrow.svg) no-repeat center;
                                background-size: 100% auto;
                            }
                        }
                        .prev {
                            border-right: none;
                        }
                        .next {
                            &::before {
                                transform: translate(-50%, -50%) rotate(180deg);
                                transform-origin: center;
                            }
                        }
                        .prev:hover,
                        .next:hover {
                            background: rgba(255, 255, 255, 0.3);
                            &::before {
                                background: url(../assets/image/business/slide_arrow_on.svg) no-repeat center;
                                background-size: 100% auto;
                            }
                        }
                    }
                }
                .desc {
                    position: absolute;
                    top: 50%;
                    left: 375px;
                    color: rgba($color: #fff, $alpha: 0.7);
                    font-size: 16px;
                    line-height: 24px;
                    letter-spacing: -1px;
                    // transform: translateY(-50%);

                    a {
                        display: none;
                    }
                    .link-3 {
                        display: inline-block;
                        margin-top: 40px;
                        width: 175px;
                        height: 46px;
                        font-size: 14px;
                        line-height: 46px;
                        letter-spacing: 0;
                        text-align: center;
                        background: url(../assets/image/main/button.svg) no-repeat center;
                        background-size: 100% auto;

                        &:hover {
                            color: #fff;
                            background: url(../assets/image/main/button-hover.svg) no-repeat center;
                            background-size: 100% auto;
                        }
                    }
                }
            }
        }
    }
    .gradient-box-enter-active,
    .gradient-box-leave-active {
        transition: transform 1000ms;
    }
    .gradient-box-enter,
    .gradient-box-leave-active {
        transform: translateX(-25px);
    }
    // .category-enter-active,
    // .category-leave-active {
    // transition: opacity .5s;
    // }
    // .category-enter,
    // .category-leave-to {
    // opacity: 0;
    // }
    .category-enter {
        opacity: 0;
    }
    .category-enter-active {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;
        transition: opacity 500ms;
    }
    .category-leave-active {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 0;
        transition: opacity 500ms;
    }
    .category-enter-to {
        opacity: 1;
    }
    .category-leave {
        opacity: 1;
    }
    .category-leave-to {
        opacity: 0;
    }
    .category-content {
        opacity: 0;
        transition: opacity 750ms;

        .box {
            opacity: 0;
            transform: translate(-40px, -50%);
            transition: opacity 1000ms 250ms, transform 1000ms 250ms;
        }
        .desc {
            opacity: 0;
            transform: translateY(-40%);
            transition: opacity 1000ms 500ms, transform 1000ms 500ms;
        }
    }
    .category-content.is-active {
        opacity: 1;

        .box {
            opacity: 1;
            transform: translate(0, -50%);
        }
        .desc {
            opacity: 1;
            transform: translateY(-50%);
        }
    }
}
@include desktop-small {
    .box-wrapper {
        width: calc(1024px - 56px);
    }
    .content {
        .desktop {
            .shape-wrapper {
                width: 1024px;
            }
            .category-title {
                width: calc(1024px - 56px);
                margin: 0 auto;
            }
            .category-content {
                width: 100%;
                .item-inner {
                    width: calc(1024px - 56px);
                }
                .desc {
                    left: 380px;
                }
            }
        }
    }
}
@media (min-width: 1600px) {
    .content .desktop {
        .category-content {
            width: 1600px;
            margin: 0 auto 100px;
        }
    }
}
@include under-tablet {
    .box-wrapper {
        width: calc(100% - 56px);
        margin-left: 28px;
        transform: translateY(-10vw);
    }
    .business-box {
        padding: 6vw;
        &__label {
            display: none;
        }
        &__text {
            color: #fff;
            .title {
                font-size: 4.4vw;
            }
            .desc {
                margin-top: 6vw;
                font-size: 2.8vw;
                line-height: 4.6vw;
                letter-spacing: -0.2vw;
                opacity: 0.7;
            }
        }
    }
    .content {
        .category {
            padding: 0 28px;
            .item {
                position: relative;
                padding-top: 7vw;
                border-bottom: 1px solid #e0e0e0;
                &:first-child {
                    padding-top: 0;
                    &::after {
                        margin-top: -7vw;
                    }
                }
                &:last-child {
                    margin-bottom: 7vw;
                }
                &::after {
                    content: '';
                    display: block;
                    position: absolute;
                    top: 20.5vw;
                    right: 28px;
                    width: 3vw;
                    height: 3vw;
                    border: solid #d3d3d3;
                    border-width: 2px 2px 0 0;
                    transform: translate(50%, -50%) rotate(135deg);
                    transition: transform 250ms
                }
                .top-point {
                    position: absolute;
                    top: -80px;
                    width: 0;
                    height: 0;
                }
                .title-wrapper {
                    overflow: hidden;
                    position: relative;
                    .symbol {
                        width: 30vw;
                        height: 30vw;
                        margin-left: 28px;
                        @for $i from 1 to 5 {
                            &.symbol#{$i} {
                                background: url(../assets/image/business/icon0#{$i}.svg) no-repeat center;
                                background-size: 100% auto;
                            }
                        }
                        @for $i from 1 to 5 {
                            &.symbol#{$i}.is-active-#{$i} {
                                background: url(../assets/image/business/icon0#{$i}-active.svg) no-repeat center;
                                background-size: 100% auto;
                            }
                        }
                    }
                    .title {
                        position: absolute;
                        top: 50%;
                        left: 40vw;
                        color: #444;
                        font-size: 4.2vw;
                        letter-spacing: -0.2vw;
                        transform: translateY(-50%);
                    }
                }
                .desc-wrapper {
                    margin-top: 7vw;
                    background: #ccc;
                    .desc {
                        padding: 15vw 14px;
                        color: #fff;
                        font-size: 3.6vw;
                        line-height: 5.6vw;
                        letter-spacing: -0.1vw;
                        text-align: center;

                        a {
                            display: inline-block;
                            width: 38vw;
                            height: 12vw;
                            margin-top: 4vw;
                            font-size: 3.2vw;
                            line-height: 12vw;
                            background: url(../assets/image/main/button.svg) no-repeat center;
                            background-size: 100% auto;
                            opacity: 0.8;

                            &:hover {
                                opacity: 1;
                                color: #fff;
                                background: url(../assets/image/main/button-hover.svg) no-repeat center;
                                background-size: 100% auto;
                            }
                        }
                    }
                    @for $i from 1 to 5 {
                        &.desc#{$i} {
                            background: url(../assets/image/business/category_0#{$i}_m.png) no-repeat center;
                            background-size: cover;
                        }
                    }
                }

                &.is-active {
                    &::after {
                        transform: translateY(0%) rotate(-45deg);
                    }
                }
            }
            .item:nth-child(1),
            .item:nth-child(2),
            .item:nth-child(4) {
                .desc-wrapper {
                    .desc a {
                        display: none;
                    }
                }
            }
        }
    }
}
@include mobile {
    .box-wrapper {
        width: calc(100% - 40px);
        margin-left: 20px;
    }
    .content {
        .category {
            padding: 0 20px;
            .item {
                &::after {
                    right: 20px;
                }
                .top-point {
                    top: -64px;
                }
                .title-wrapper {
                    .symbol {
                        margin-left: 20px;
                    }
                }
                .desc-wrapper {
                    .desc {
                        padding: 15vw 10px;
                    }
                }
            }
        }
    }
}
</style>

<style scoped>
.business .content .desktop .category-content .item .desc >>> strong {
    display: block;
    margin-top: 40px;
    margin-bottom: 8px;
    font-size: 19px;
}
.business .content .desktop .category-content .item .desc >>> strong.first {
    margin-top: 0;
}
.business .content .mobile .category .item .desc >>> strong {
    display: block;
    font-weight: 700;
    font-size: 4.2vw;
    margin-top: 8vw;
    margin-bottom: 3vw;
}
.business .content .mobile .category .item .desc >>> p {
    opacity: 0.8;
}
.business .content .mobile .category .item .desc >>> strong.first {
    margin-top: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/Business.vue